module.exports = __webpack_public_path__ + "img/g_zdu.71f100ec.png";